const addScript = () => {
  //<script src="/cdn-cgi/zaraz/i.js" referrerpolicy="origin"></script>
  // const ver = new Date().getTime();
  // const url = require("./../../global/url");
  // const zarazScript = document.createElement("script");
  // zarazScript.setAttribute("id", "zaraz-script");
  // zarazScript.setAttribute("src", `${url.start}/cdn-cgi/zaraz/i.js`);
  // zarazScript.setAttribute("referrerpolicy", "origin");

  // if(!document.querySelector("#zaraz-script")) document.querySelector("head")?.append(zarazScript);
}

module.exports = addScript;